import { constant } from 'lodash/fp';
import { combineReducers } from 'redux';

import { metaInitialState, setMetaFailed, setMetaStarted, setMetaSucceeded } from '@mews-distributor/common';
import { keyById } from '@mews/fp';
import { createReducer } from '@mews/framework/redux';

import { BOOKING_RESTARTED } from '../../global/actionTypes';
import { FETCH_PAYMENT_CARDS_FAILED, FETCH_PAYMENT_CARDS_STARTED, FETCH_PAYMENT_CARDS_SUCCEEDED } from './actionTypes';
import { FetchPaymentCardsResponse, PaymentCardsData } from './types';

const dataInitialState: PaymentCardsData = {};

const dataReducer = createReducer(dataInitialState, {
    [FETCH_PAYMENT_CARDS_SUCCEEDED]: (state: PaymentCardsData, { paymentCards }: FetchPaymentCardsResponse) => ({
        ...state,
        ...keyById(paymentCards),
    }),
    [BOOKING_RESTARTED]: constant(dataInitialState),
});

const metaReducer = createReducer(metaInitialState, {
    [FETCH_PAYMENT_CARDS_STARTED]: setMetaStarted,
    [FETCH_PAYMENT_CARDS_SUCCEEDED]: setMetaSucceeded,
    [FETCH_PAYMENT_CARDS_FAILED]: setMetaFailed,
});

export const paymentCards = combineReducers({
    data: dataReducer,
    meta: metaReducer,
});
